<template>
  <tela-component title="Central de Pedidos" rota="/">
    <btn-novo-pedido />
    <v-card flat rounded="lg" class="mt-2">
      <v-card-text>
        <v-row dense>
          <v-col xl="auto" lg="auto" md="auto" cols="12" align-self="center">
            <btn-filtro-central-pedidos />
          </v-col>
          <v-spacer></v-spacer>
          <v-col xl="10" lg="10" md="10" cols="12">
            <v-text-field
              label="Pesquisar"
              v-model="pesquisa"
              placeholder="Pesquise por cliente, nº pedido, cidade"
            ></v-text-field>
          </v-col>
        </v-row>        
        <v-data-table
          :loading="loading"
          loading-text="Carregando pedidos..."
          no-data-text="Nenhum pedido encontrado"
          no-results-text="Nenhum pedido localizado"
          :headers="headers"
          :items="pedidos"
          item-key="id"
          :single-expand="!isMobile()"
          :show-expand="!isMobile()"
          :search="pesquisa"
          :header-props="headerPropsTabela()"
        >
          <template v-slot:[`item.emissao`]="{ item }">
            {{ formatarData(item.emissao) }}
          </template>
          <template v-slot:[`item.datanf`]="{ item }">
            {{ formatarData(item.datanf) }}
          </template>
          <template v-slot:[`item.cidade`]="{ item }">
            {{ item.cidade }}/{{ item.uf }}
          </template>
          <template v-slot:[`item.status`]="{ item }">
            <chip-status-pedido :pedido="item" />
          </template>
          <template v-slot:[`item.desctipopedido`]="{ item }">
            <v-chip
              x-small
              v-if="item.desctipopedido != ''"
              color="black"
              dark
              outlined
              >{{ item.desctipopedido }}</v-chip
            >
          </template>
          <template v-slot:[`item.actions`]="{ item }">
            <btn-cancelar-pedido :pedido="item" v-if="item.podecancelar" />
            <btn-perfil-cliente
              :cliente="{
                matricula: item.pessoa,
                nome: item.descpessoa,
                carregardadoscliente: true,
              }"
            />
            <btn-imprimir-pedido :pedido="item" icon />
          </template>
          <template v-slot:[`item.detalhes`]="{ item }" v-if="isMobile()">
            <btn-mais-detalhes :pedido="item" />
          </template>
          <template v-slot:expanded-item="{ headers, item }">
            <td :colspan="headers.length" class="white">
              <card-itens-pedido :pedido="item" class="mt-2" />
            </td>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </tela-component>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import moment from "moment";
import ChipStatusPedido from "@/components/pedidos/central-pedidos/ChipStatusPedido.vue";
import BtnPerfilCliente from "@/components/perfil-cliente/BtnPerfilCliente.vue";
import { formatMoeda } from "@/global";
import TelaComponent from "@/components/tela/TelaComponent.vue";
import BtnMaisDetalhes from "@/components/pedidos/central-pedidos/BtnMaisDetalhes.vue";
import CardItensPedido from "@/components/pedidos/central-pedidos/CardItensPedido.vue";
import BtnImprimirPedido from "@/components/pedidos/central-pedidos/BtnImprimirPedido.vue";
import BtnFiltroCentralPedidos from "@/components/pedidos/central-pedidos/BtnFiltroCentralPedidos.vue";
import BtnNovoPedido from "@/components/pedidos/novo-pedido/botoes/BtnNovoPedido.vue";
import BtnCancelarPedido from "@/components/pedidos/central-pedidos/BtnCancelarPedido.vue";

export default {
  components: {
    TelaComponent,
    ChipStatusPedido,
    BtnPerfilCliente,
    BtnMaisDetalhes,
    CardItensPedido,
    BtnImprimirPedido,
    BtnFiltroCentralPedidos,
    BtnNovoPedido,
    BtnCancelarPedido,
  },
  computed: mapState("pedidos", ["pedidos"]),
  data: () => ({
    loading: true,
    pesquisa: "",
    headers: [
      { text: "Filial", value: "filial" },
      { text: "Pedido", value: "nrpedido" },
      { text: "Emissão", value: "emissao" },
      { text: "Dt.Fatur", value: "datanf" },
      { text: "Status", value: "status" },
      { text: "Cliente", value: "descpessoa" },
      { text: "Cidade", value: "cidade" },
      { text: "Form.Carga", value: "formacoes_carga" },
      { text: "", value: "desctipopedido" },
      { text: "", value: "actions", sortable: false, width: 140, align: "end" },
      { text: "", value: "detalhes" },
    ],
  }),
  methods: {
    ...mapActions("pedidos", ["getPedidos"]),
    ...mapGetters("sistema", ["headerPropsTabela"]),
    formatarData(value) {
      if (value == "" || value == null) return "";
      return moment(value).format("DD/MM/YYYY");
    },
    isMobile() {
      return this.$mq == "sm";
    },
    formatarMoeda(value, cd = 2) {
      return formatMoeda(value, cd);
    },
    getKeyTable(value) {
      return `${value.id}${value.status}`;
    },
  },
  async created() {
    this.loading = true;

    if (!this.isMobile()) {
      this.headers.pop();
    }

    await this.getPedidos();
    this.loading = false;
  },
};
</script>

<style>
.v-data-table > .v-data-table__wrapper .v-data-table__mobile-row {
  min-height: 30px !important;
}
</style>

